import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../../../_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { ENUM__image_asset_category } from '../../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../../_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '../../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../../_base/INVOCATION__base';

export class INVOCATION_VISION_ML__depth_anything extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_VISION_ML__DEPTH_ANYTHING;

  /*
   * FIELDS
   */
  @FIELD_PRIMITIVE__string_hash_ml_asset.init_input_with_type(ENUM__ml_asset_type.VISION)
  model!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD__image_asset.init_as_input({ category: ENUM__image_asset_category.IMAGE })
  image!: FIELD__image_asset;

  /*
   * OUTPUT
   */

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.DEPTH })
  out!: FIELD__image_asset;

  /*
   *
   */
  get family() {
    return ENUM__ml_asset_family.VISION_DEPTH_ANYTHING;
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.VISION_ML__DEPTH_ANYTHING);
  }
}
